// extracted by mini-css-extract-plugin
module.exports =  {"copySection":"copySection__3GFgD"};